import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  getParameterData,
  getParametersForPipelineAsync,
  setAlertData,
  setAlertData2,
  setParameterData,
} from "../MonitorSlice"
import { ALERT_STATUS_MSGS } from "../../../util/StaticData"
import NewPipeLineTableWrapper from "./NewPipeLineTableWrapper"
import NewPipeLineConfigTable from "../../../components/NewPipeLineConfigTable"
import { convertMonthYearParamsToDate } from "../../../util/CommonMethods"
import { Box, CircularProgress } from "@mui/material"

interface PipelineTableWrapperProps {
  parameterOrConfig: string
  pipelineSelectedValue: string
}

const PipelineTableWrapper: React.FC<PipelineTableWrapperProps> = ({
  parameterOrConfig,
  pipelineSelectedValue,
}) => {
  const dispatch = useDispatch()
  const [loadingParams, setLoadingParams] = React.useState(false)
  const parameterData = useSelector(getParameterData)

  useEffect(() => {
    if (parameterOrConfig === "Parameters") {
      fetchPipelineParameters()
    }
  }, [parameterOrConfig, pipelineSelectedValue])

  const fetchPipelineParameters = async () => {
    setLoadingParams(true)

    const response = await dispatch(
      getParametersForPipelineAsync({
        pipeline_name: pipelineSelectedValue,
      }) as any,
    )

    if (response.payload?.data) {
      const convertedParams = convertMonthYearParamsToDate(
        response.payload?.data,
      )
      dispatch(setParameterData(convertedParams))
    } else {
      dispatch(
        setAlertData2(
          setAlertData(
            response.payload?.message || "Failed to fetch parameters.",
            ALERT_STATUS_MSGS.ERROR,
            true,
          ),
        ),
      )
    }
    setLoadingParams(false)
  }

  const handleParameterChange = (changeDetails: any) => {
    const updatedParameters = parameterData.map((param: any, index: number) => {
      if (index === changeDetails.rowIndex) {
        const checkForYearMonth = param.param_name.includes("year_month")
          ? changeDetails.value.toISOString()
          : changeDetails.value
        return { ...param, default_value: checkForYearMonth }
      }
      return param
    })
    dispatch(setParameterData(updatedParameters))
  }

  if (loadingParams) {
    return (
      <Box
        sx={{
          minHeight: 500,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  return (
    <>
      {parameterOrConfig === "Config" ? (
        <NewPipeLineTableWrapper />
      ) : (
        <NewPipeLineConfigTable
          activeTab="Parameters"
          data={parameterData}
          cellChange={handleParameterChange}
        />
      )}
    </>
  )
}

export default PipelineTableWrapper
